export default {
      id: "twitter-usage",
      viewBox: "0 0 15 13",
      url: "../../assets/" + "sprite.svg#twitter-usage",
      toString: function () {
        return this.url;
      }
    }